export default function currentStep(state = 1, action) {
  if (action.type === 'SET_STEP') {
    return action.payload;
  } else if (action.type === 'RESET_STEP') {
    return 1;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/data/currentStep.js
 **/